import { render, staticRenderFns } from "./DocumentsFolderPicker.vue?vue&type=template&id=0af23ba8&scoped=true&"
import script from "./DocumentsFolderPicker.vue?vue&type=script&lang=js&"
export * from "./DocumentsFolderPicker.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsFolderPicker.vue?vue&type=style&index=0&id=0af23ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af23ba8",
  null
  
)

export default component.exports